import { BaseController } from "../../base/controller";
import {
	agbStateName,
	privacyStateName,
	imprintStateName,
} from "../../../components/legal/legal.state";

export class AppFooterController extends BaseController {
	constructor(
		controllerService,
		uiModalDeclarationService,
		$scope,
		configService,
	) {
		"ngInject";
		super({
			controllerService,
			uiModalDeclarationService,
			$scope,
			configService,
		});
	}

	$onInit() {
		this.agbStateName = agbStateName;
		this.privacyStateName = privacyStateName;
		this.imprintStateName = imprintStateName;
	}
}



// WEBPACK FOOTER //
// ./src/app/common/ui/appFooter/appFooter.controller.js